import { DropdownSort, pxToRem, useStyles } from '@archipro-design/aria';
import { CustomCaretDown, CustomCaretUp } from '@archipro-design/icons';
import type { SearchSortOptionResult } from '../../hook/use-search-sort-options';
import * as S from './SearchSort.style';

interface SearchSortProps {
    optionResult: SearchSortOptionResult;
}

const SearchSort = ({ optionResult }: SearchSortProps) => {
    const { items, value } = optionResult;
    const { css } = useStyles();

    return (
        <DropdownSort
            aria-labelledby="sort-dropdown-button"
            className={css(S.DropdownSortWrapper)}
            checkable
            renderItem={(Component, componentProps) => {
                return <Component {...componentProps} />;
            }}
            value={value}
            items={items}
            expandIcon={<CustomCaretUp />}
            collapseIcon={<CustomCaretDown />}
            variables={{
                primaryDropdownFontSize: pxToRem(18),
                dropdownItemFontSize: pxToRem(18),
                checkIconWidth: pxToRem(16),
                checkIconHeight: pxToRem(16),
                iconLabelGap: pxToRem(3),
            }}
            styles={{
                fontWeight: 500,
            }}
            list={{
                id: 'search-filter-popup',
            }}
        />
    );
};

export default SearchSort;
